import styles from './index.less';
import React, { useState } from 'react';
import QuestionBankCategory from '@/pages/backend/QuestionSettings/QuestionBankCategory';
import QuestionDetails from '@/pages/backend/QuestionSettings/QuestionDetails';
import { TQuestionBankCategory } from '@/types/QuestionBank';

const QuestionSettings = () => {
  const [selected, setSelected] = useState<TQuestionBankCategory>();
  const [refresh, setRefresh] = useState<number>(1);
  const [isEditingTitle, setIsEditingTitle] = useState<boolean>(false);
  return (
    <div className={styles.container}>
      <div className={styles.left}>
        <QuestionBankCategory
          onCreate={(created) => {
            setIsEditingTitle(true);
          }}
          onSelect={(value) => {
            if (value) {
              setSelected(value);
            }
          }}
          refresh={refresh}
          setRefresh={setRefresh}
        />
      </div>
      <div className={styles.right}>
        <QuestionDetails
          isEditingTitle={isEditingTitle}
          setIsEditingTitle={setIsEditingTitle}
          category={selected}
          refresh={refresh}
          setRefresh={setRefresh}
        />
      </div>
    </div>
  );
};

export default QuestionSettings;
